import { render, staticRenderFns } from "./SiteAdd.vue?vue&type=template&id=bb8fb7ba&"
import script from "./SiteAdd.vue?vue&type=script&lang=js&"
export * from "./SiteAdd.vue?vue&type=script&lang=js&"
import style0 from "./SiteAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports